import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, TableRow, Paper, Table, TableBody, TableCell, TableContainer, TableHead, LinearProgress, Box, CircularProgress, DialogContentText, IconButton } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import useApiRequest from '../services/apiRequest';
import endpoints from '../constants/endpoints';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import { User } from 'oidc-client';
import useAuth from '../hooks/useAuth';
import navbar_background from '../assets/navbar_background.svg';
import { Close } from '@mui/icons-material';


function ReportsDialog() {
    const { downloadFile, get, remove} = useApiRequest();

    const [data, setData] = useState<any[]>([]);
    const { userPermissions } = useContext(GlobalStateContext);
    const { openReportsDialog, setOpenReportsDialog } = React.useContext(GlobalStateContext);
    const [openConfirmDelete, setOpenConfirmDelete] = React.useState(false);
    const [selectedRow, setSelectedRow] = React.useState<any>({});
    const {currentUser, setCurrentUser} = React.useContext(GlobalStateContext);
    const { getUser } = useAuth();
    const [isFetchingFiles, setIsFetchingFiles] = useState(false);
    const [isDownloading, setIsDownloading] = useState<string[]>([]);

    const loadUser = async () => {
        let u: User | null = null;
        if (localStorage.getItem("user")) {
            u = JSON.parse(localStorage.getItem("user") || "") as User;
        } else {
            u = await getUser();
        }

        if (u)
            setCurrentUser(u);
    }

    const getFiles = async () => {
        let result = await get(endpoints.GET_USER_FILES + `/${currentUser?.profile.username}`)
        setData(result);
        let achou = false;
        for (let i = 0; i < result.length; i++) {
            const element = result[i];
            if (element.status == false) {
                achou = true;
            }
        }

        if (achou && openReportsDialog) {
            setTimeout(getFiles, 5000);
        } else {
            setIsFetchingFiles(false);
        }
    }

    const download = async (row: any) => {
        try {
            setIsDownloading((prevIsDownloading) => [...prevIsDownloading, row.token]);
            var partes = row.data.split(/[\/\s:]/);
            var nomeArquivo = partes[0] + '-' + partes[1] + '-' + partes[2] + '_' + partes[3] + '-' + partes[4] + '-' + partes[5];
            await downloadFile(endpoints.GET_FILE + `/${currentUser?.profile.username}`, { token: row.token }, `${row.consulta}_${nomeArquivo}.${row.tipo_arquivo}`);
            setIsDownloading((prevIsDownloading) => prevIsDownloading.filter(token => token !== row.token));
        } catch (error) {
            setIsDownloading((prevIsDownloading) => prevIsDownloading.filter(token => token !== row.token));
        }

    }

    const handleDelete = async (row: any) => {
        await remove(endpoints.DELETE_FILE + `?user=${currentUser?.profile.username}&token=${row.token}`);
        let result = await get(endpoints.GET_USER_FILES + `/${currentUser?.profile.username}`);
        setData(result);
    }

    useEffect(() => {
        if (openReportsDialog && !isFetchingFiles) {
            setIsFetchingFiles(true);
            getFiles();
        }
    }, [openReportsDialog])

    const handleClose = () => {
        setOpenReportsDialog(false);
    }

    return (
        <>
            <Dialog
                open={openConfirmDelete}
                onClose={() => { setOpenConfirmDelete(false) }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" sx={{ bgcolor: '#f5f2f2' }}>
                    <Typography variant="h5" color="initial">Realmente deseja excluir esse relátorio?</Typography>
                </DialogTitle>
                <DialogContent>
                    <Table sx={{ minWidth: 300 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell ><Typography variant="h6" color="initial">Data</Typography></TableCell>

                                <TableCell ><Typography variant="h6" color="initial">Descrição</Typography></TableCell>
                                <TableCell><Typography variant="h6" color="initial">Formato</Typography></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow
                                key={selectedRow.token}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell style={{ borderBottom: "none" }} ><Typography variant="h6" color="initial">{selectedRow.data || 'carregando...'}</Typography></TableCell>
                                <TableCell style={{ borderBottom: "none" }} >
                                    <Typography variant="h6" color="initial">{selectedRow.consulta}</Typography>
                                </TableCell>
                                <TableCell style={{ borderBottom: "none" }} >
                                    <Typography variant="h6" color="initial">{selectedRow.tipo_arquivo}</Typography>
                                </TableCell>

                            </TableRow>

                        </TableBody>
                    </Table>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' onClick={() => { setOpenConfirmDelete(false) }}>Cancelar</Button>
                    <Button variant='contained' color='error' startIcon={<DeleteIcon />} onClick={() => { handleDelete(selectedRow); setOpenConfirmDelete(false) }} autoFocus>
                        Excluir
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={openReportsDialog}
                onClose={() => { handleClose() }}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth={false}
                keepMounted={false}

            >
                <DialogTitle color='white'  sx={{bgcolor: '#00617b' , backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }} >
                    <Typography variant="h4">Relatórios</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={() => { handleClose() }}
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                        }}
                    >
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ textAlign: 'center', m: 2 }}>

                    {data.length > 0
                        ?

                        <TableContainer component={Paper}>

                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell ><Typography variant="h5" color="initial">Data</Typography></TableCell>

                                        <TableCell ><Typography variant="h5" color="initial">Descrição</Typography></TableCell>
                                        <TableCell><Typography variant="h5" color="initial">Formato</Typography></TableCell>
                                        <TableCell align='right' ><Typography variant="h5" color="initial">Download</Typography></TableCell>
                                        <TableCell align='right' ><Typography variant="h5" color="initial">Excluir</Typography></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data.map((row) => (
                                        <TableRow
                                            key={row.token}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell style={{ borderBottom: "none" }} ><Typography variant="h6" color="initial">{row.data || 'carregando...'}</Typography></TableCell>
                                            <TableCell style={{ borderBottom: "none" }} >
                                                <Typography variant="h6" color="initial">{row.consulta}</Typography>
                                            </TableCell>
                                            <TableCell style={{ borderBottom: "none" }} >
                                                <Typography variant="h6" color="initial">{row.tipo_arquivo}</Typography>
                                            </TableCell>
                                            <TableCell style={{ borderBottom: "none" }} align="right">

                                                {row.status ?
                                                    isDownloading.includes(row.token) ? <CircularProgress /> :
                                                        <Button disabled={!userPermissions.get_file} variant="outlined" startIcon={<DownloadIcon />} onClick={() => download(row)}>
                                                            Download
                                                        </Button>
                                                    :
                                                    <Box sx={{ display: 'flex', maxWidth: '50%', ml: '60%' }}>
                                                        <CircularProgress />
                                                    </Box>

                                                }
                                            </TableCell>
                                            <TableCell style={{ borderBottom: "none" }} align="right">

                                                {row.status ?
                                                    isDownloading.includes(row.token) ? <CircularProgress  /> :
                                                        <Button disabled={!userPermissions.delete_file} variant="outlined" color='error' startIcon={<DeleteIcon />} onClick={() => { setSelectedRow(row); setOpenConfirmDelete(true) }}>
                                                            Excluir
                                                        </Button>
                                                    :
                                                    <></>

                                                }
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        :

                        <Typography variant='h6'>Sem arquivos para download</Typography>
                    }

                </DialogContent>
            </Dialog >
        </>

    );
}

export default ReportsDialog;
